var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("circle", {
  id: "Ellipse",
  cx: 6,
  cy: 6,
  r: 6,
  fill: "#D9D9D9"
});

var _ref3 = /*#__PURE__*/React.createElement("g", {
  mask: "url(#mask0_5605_44981)"
}, /*#__PURE__*/React.createElement("rect", {
  id: "Fill",
  x: -0.544922,
  y: -0.544922,
  width: 13.0909,
  height: 13.0909,
  fill: "#038F00"
}));

var _ref4 = /*#__PURE__*/React.createElement("path", {
  id: "Shape",
  d: "M8.61288 4.27144C8.40056 4.04276 8.04858 4.0392 7.83208 4.26414L5.39396 6.79721L4.16659 5.52203C3.95009 5.29709 3.59811 5.30065 3.38579 5.52933C3.17875 5.75234 3.18161 6.107 3.3927 6.32631L5.39396 8.40552L8.60597 5.06841C8.81706 4.8491 8.81992 4.49444 8.61288 4.27144Z",
  fill: "white"
});

function SvgValidateSuccess(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "Group 12423"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Mask group"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_5605_44981",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 12,
    height: 12
  }, _ref2), _ref3), _ref4));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgValidateSuccess);
export default __webpack_public_path__ + "static/media/validate-success.50ffc6c6.svg";
export { ForwardRef as ReactComponent };